import { v4 as uuidv4 } from 'uuid';

import { createKnmDocumentTypeSelectOption } from 'CorePackage/CatalogsModule/common/createKnmDocumentTypeSelectOption';
import { IKnmEvent248Protocol } from 'APIPackage/KnmModule/interfaces/IKnmEvent248Protocol';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';

import { IKnmErknmFormEventProtocol } from '../interfaces/IKnmErknmFormEventProtocol';
import { IKnmErknmEventSubmittedDocumentsForm } from '../interfaces/IKnmErknmEventSubmittedDocumentsForm';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const convertInitialKnmDataEventsProtocolsToFormData = (
  protocol?: IKnmEvent248Protocol | undefined,
): IKnmErknmFormEventProtocol | undefined => {
  if (!protocol) {
    return undefined;
  }
  const protocolResult: IKnmErknmFormEventProtocol = {
    guid: protocol.guid,
    appendicesToTheProtocolOfAction: protocol.appendicesToTheProtocolOfAction?.map(document => {
      return {
        ...document,
        descriptionReactQuillEditor: handleReactQuillDeltaValue(
          document?.descriptionReactQuillEditor || document?.description || undefined,
        ),
        type: document?.type ? createKnmDocumentTypeSelectOption(document?.type) : undefined,
        attachments: document.attachments || undefined,
        listId: document.guid || uuidv4(),
      };
    }),
    studiedDocuments: !protocol.studiedDocuments
      ? undefined
      : protocol.studiedDocuments.map(doc => {
          const document: IKnmErknmEventSubmittedDocumentsForm = {
            ...doc,
            isNew: false,
            requestDateTime: convertInitialKnmDateToFormDate(
              doc.requestDateTime,
              DATE_FORMAT_LONG_MINUTE_FNS,
              DATE_FORMAT_ISO_FNS,
            ),
            submissionDateTime: convertInitialKnmDateToFormDate(
              doc.submissionDateTime,
              DATE_FORMAT_LONG_MINUTE_FNS,
              DATE_FORMAT_ISO_FNS,
            ),
            submissionDeadline: convertInitialKnmDateToFormDate(doc.submissionDeadline, DATE_FORMAT_LONG_FNS),
            status: {
              code: doc.status?.code || '',
              id: doc.status?.id || 0,
              title: doc.status?.title || '',
              weight: doc.status?.weight || 0,
              label: doc.status?.title || '',
              value: doc.status?.code || '',
            },
          };

          return document;
        }),
    file: protocol.file
      ? {
          ...protocol.file,
          type: protocol.file?.type ? createKnmDocumentTypeSelectOption(protocol.file?.type) : undefined,
          attachments: protocol.file?.attachments || undefined,
          listId: protocol.file?.guid || uuidv4(),
        }
      : undefined,
  };

  return protocolResult;
};
